<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  styleClass="skill-manage-agents-dialog"
  [style]="{ width: '560px', maxWidth: '95vw' }">

  <ng-template #header>
    <div class="d-flex align-items-center gap-2">
      <i class="pi pi-users" style="font-size: 1.25rem; color: var(--acx-primary)"></i>
      <span class="fw-semibold">
        {{ 'Settings::WorkEnvironment:Skills:ManageAgents' | abpLocalization }} &mdash; {{ skill?.name }}
      </span>
    </div>
  </ng-template>

  <!-- Loading state -->
  <div *ngIf="loading" class="text-center py-4">
    <i class="pi pi-spin pi-spinner fs-4"></i>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Already assigned section -->
    <div *ngIf="alreadyAssigned.length > 0" class="mb-3">
      <div
        class="d-flex align-items-center justify-content-between border px-3 py-2"
        [class.rounded]="!isAssignedExpanded"
        [class.rounded-top]="isAssignedExpanded"
        [class.border-bottom-0]="isAssignedExpanded"
        role="button"
        tabindex="0"
        (click)="isAssignedExpanded = !isAssignedExpanded"
        (keydown.enter)="isAssignedExpanded = !isAssignedExpanded"
        (keydown.space)="$event.preventDefault(); isAssignedExpanded = !isAssignedExpanded">
        <div class="d-flex align-items-center gap-2">
          <i class="pi" [class.pi-chevron-right]="!isAssignedExpanded" [class.pi-chevron-down]="isAssignedExpanded"></i>
          <span class="fw-semibold small">
            {{ 'Settings::WorkEnvironment:Skills:AlreadyAssigned' | abpLocalization }}
            ({{ alreadyAssigned.length }})
          </span>
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="$event.stopPropagation(); onUnassignAll()">
          <i class="pi pi-user-minus me-1"></i>
          {{ 'Settings::WorkEnvironment:Skills:UnassignAll' | abpLocalization }}
        </button>
      </div>

      <div *ngIf="isAssignedExpanded" class="border border-top-0 rounded-bottom px-2 pt-1">
        <div
          *ngFor="let row of alreadyAssigned; trackBy: trackByUserId; let i = index; let last = last"
          class="d-flex align-items-center gap-2 py-2"
          [class.border-bottom]="!last">
          <span class="badge text-bg-secondary flex-shrink-0">
            {{ 'Settings::WorkEnvironment:Skills:Assigned' | abpLocalization }}
          </span>
          <cx-user-avatar [userId]="row.userId" [name]="row.name" [size]="24"></cx-user-avatar>
          <div class="flex-grow-1 small text-truncate">{{ row.displayName }}</div>
          <p-rating [(ngModel)]="row.level" [cancel]="true" />
          <button
            type="button"
            class="btn btn-link p-0 text-muted flex-shrink-0"
            (click)="onRemoveAssigned(i)">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Agent selector row -->
    <div class="d-flex gap-2 mb-3">
      <div class="flex-grow-1 min-w-0">
        <cx-multi-select
          [options]="availableAgentOptions"
          [(ngModel)]="selectedAgentIds"
          optionLabel="displayName"
          optionValue="id"
          [filter]="true"
          [selectedItemsLabel]="agentsSelectedLabel"
          [placeholder]="'Settings::WorkEnvironment:Skills:SelectAgents' | abpLocalization"
          class="w-100 d-block"
          styleClass="w-100">
        </cx-multi-select>
      </div>
      <button
        type="button"
        class="btn btn-primary btn-sm text-nowrap"
        [disabled]="!selectedAgentIds.length"
        (click)="onAdd()">
        <i class="pi pi-plus me-1"></i>
        {{ 'Settings::WorkEnvironment:Skills:Add' | abpLocalization }}
      </button>
    </div>

    <!-- New agents section -->
    <ng-container *ngIf="newAgents.length > 0">
      <div class="fw-semibold small mb-2">
        {{ 'Settings::WorkEnvironment:Skills:New' | abpLocalization }} ({{ newAgents.length }})
      </div>

      <!-- Apply to new shortcut -->
      <div class="d-flex align-items-center gap-2 py-2 mb-2 border rounded px-3">
        <span class="small text-muted flex-shrink-0">
          {{ 'Settings::WorkEnvironment:Skills:ApplyToNew' | abpLocalization }}
        </span>
        <div class="flex-grow-1"></div>
        <p-rating [(ngModel)]="applyToNewLevel" [cancel]="true" />
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm flex-shrink-0"
          [disabled]="!applyToNewLevel"
          (click)="onApplyToNew()">
          {{ 'Settings::WorkEnvironment:Skills:Apply' | abpLocalization }}
        </button>
      </div>

      <!-- New agent rows -->
      <div
        *ngFor="let row of newAgents; trackBy: trackByUserId; let i = index; let last = last"
        class="d-flex align-items-center gap-2 py-2"
        [class.border-bottom]="!last">
        <span class="badge text-bg-success text-white flex-shrink-0">
          {{ 'Settings::WorkEnvironment:Skills:New' | abpLocalization }}
        </span>
        <cx-user-avatar [userId]="row.userId" [name]="row.name" [size]="24"></cx-user-avatar>
        <div class="flex-grow-1 small text-truncate">{{ row.displayName }}</div>
        <p-rating [(ngModel)]="row.level" [cancel]="true" />
        <button
          type="button"
          class="btn btn-link p-0 text-muted flex-shrink-0"
          (click)="onRemoveNew(i)">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div
      *ngIf="alreadyAssigned.length === 0 && newAgents.length === 0"
      class="text-center py-4 text-muted">
      <i class="pi pi-users fs-2 d-block mb-2" style="color: var(--acx-border-subtle)"></i>
      <span class="small">{{ 'Settings::WorkEnvironment:Skills:NoAgentsAssigned' | abpLocalization }}</span>
    </div>
  </ng-container>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      cancelVariant="outline-secondary"
      [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
      [saveLabel]="'AbpUi::Save' | abpLocalization"
      saveType="button"
      [disabled]="!canSave || saving"
      [isSubmitting]="saving"
      (cancel)="onCancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>
